import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { LangEnum } from "@models/interface-management/localization";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";

export class LocationConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Location;
  isCrudByModal = true;
  showRestore = true;

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      title: "dicTable.code",
      name: "code",
      type: HardFormFieldTypeEnum.Input,
    },
    {
      title: "dicTable.sortOrder",
      name: "sortOrder",
      type: HardFormFieldTypeEnum.Number,
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<any> = {
    showDefaultActions: true,
    tableColumns: "40px repeat(3,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.code",
        name: "code",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
    ],
  };
}
